import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const previousPathRef = useRef(pathname);

  useEffect(() => {
    const previousPath = previousPathRef.current;
    
    // Check if returning to home from expertise subpages
    const expertisePages = ["/workshops", "/training", "/advice-reports", "/implementations"];
    if (pathname === "/" && expertisePages.includes(previousPath)) {
      // Scroll to services section
      setTimeout(() => {
        const servicesSection = document.getElementById("services");
        if (servicesSection) {
          servicesSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else if (pathname !== "/") {
      // Scroll to top for non-home pages
      window.scrollTo(0, 0);
    }
    
    // Update previous path
    previousPathRef.current = pathname;
  }, [pathname]);

  return null;
};
